export default __webpack_public_path__ + "static/media/logo.e3fccff6.png";